export default "__VITE_ASSET__420bacc2__"